import { CommentResource as LegacyCommentResource } from '../../../models'
import { transformBaseScheduleIndex } from '../BaseSchedule/BaseScheduleTransformers'
import { UserResource } from '../User/User'
import { transformToBasicUser, transformUserWithPersonV3Resource } from '../User/UserTransformers'
import {
    AddCommentFormData,
    AddCommentRequest,
    Comment,
    CommentResource,
    ConceptDayComment,
    ConceptDayCommentV3Resource,
} from './Comment'

export const transformToComment = (
    commentResource: CommentResource,
    userResource: UserResource,
): Comment => ({
    id: commentResource.id,
    body: commentResource.attributes.body,
    type: commentResource.attributes.type,
    createdAt: new Date(commentResource.attributes.createdAt),
    owner: transformToBasicUser(userResource),
})

export const transformLegacyCommentToComment = (
    legacyCommentResource: LegacyCommentResource,
    userResource?: UserResource,
): Comment => ({
    id: legacyCommentResource.id,
    type: legacyCommentResource.type,
    body: legacyCommentResource.body,
    createdAt: new Date(legacyCommentResource.createdAt),
    owner: userResource ? transformToBasicUser(userResource) : undefined,
})

export const transformCommentFormDataToRequest = (
    formData: AddCommentFormData,
): AddCommentRequest => ({
    type: 'comments',
    attributes: {
        body: formData.comment,
    },
    relationships: {
        [formData.relationshipKey]: {
            data: {
                type: formData.relationshipType,
                id: formData.relationshipId,
            },
        },
    },
})

export const transformToConceptDayComment = (
    commentResource: ConceptDayCommentV3Resource,
): ConceptDayComment => ({
    ...commentResource,
    id: commentResource.uuid,
    date: new Date(commentResource.date),
    owner: transformUserWithPersonV3Resource(commentResource.owner),
    baseSchedule: transformBaseScheduleIndex({
        uuid: commentResource.baseSchedule.uuid,
        name: commentResource.baseSchedule.name,
        totalWeeks: commentResource.baseSchedule.totalWeeks ?? 1,
        createdBy: commentResource.baseSchedule.createdBy ?? null,
        departments: commentResource.baseSchedule.departments ?? [],
        createdAt: commentResource.baseSchedule.createdAt ?? null,
        updatedAt: commentResource.baseSchedule.updatedAt ?? null,
    }),
})
